const PLACEHOLDER_VENUES = new Set([
  'venue', 'select venue', 'select a venue', 'choose venue', 'choose a venue',
  'not specified', 'unspecified',
]);

export const isRealVenueName = value => {
  const normalized = String(value || '').trim();
  return Boolean(normalized) && !PLACEHOLDER_VENUES.has(normalized.toLowerCase());
};

export const sanitizeVenueNames = values => [
  ...new Set((Array.isArray(values) ? values : []).map(value => String(value).trim()).filter(isRealVenueName)),
];
